import request from '@/config/axios';

/**
 * 平台管理端 — 类目申请审核 API
 * 使用 request（/admin-api 前缀），用于平台管理员审核商家类目申请
 */

// 获取类目申请分页
export function getCategoryApplyPage(params: {
  pageNo: number;
  pageSize: number;
  applyStatus?: number;
  shopId?: number;
}) {
  return request.get({ url: '/merchant/category-apply/page', params });
}

// 审核类目申请（通过/驳回）
// 根据 ADR-006：审核通过时需传入佣金率，审核界面默认填入类目默认佣金率，审核人可手动调整
export function auditCategoryApply(data: {
  applyId: number;
  approved: boolean;
  reason?: string;
  commissionRate?: number; // 佣金率(%)，审核通过时必填
}) {
  return request.post({ url: '/merchant/category-apply/audit', data });
}

// 获取经营类目列表（含默认佣金率，供审核时参考）
export function getCategoryList(params?: { name?: string; status?: number }) {
  return request.get({ url: '/product/category/list', params });
}
